(() => {
  function mount(root) {
    if(root.dataset.ready)return;root.dataset.ready='true';
    if(root.classList.contains('cf31-catalog--breaks'))return;
    root.querySelectorAll('.cf31-product__image').forEach(frame=>{const image=frame.querySelector('img');if(!image)return;const backdrop=image.cloneNode();backdrop.removeAttribute('id');backdrop.alt='';backdrop.setAttribute('aria-hidden','true');backdrop.classList.add('cf31-image-backdrop');frame.prepend(backdrop);});
    const grid=root.querySelector('[data-catalog-grid]'),cards=[...grid.children];
    const search=root.querySelector('[data-catalog-search]'),stock=root.querySelector('[data-catalog-stock]'),sort=root.querySelector('[data-catalog-sort]');
    const sport=root.querySelector('[data-catalog-sport]');
    const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
    function category(card){
      if(card.dataset.sport)return card.dataset.sport;
      const t=norm(card.dataset.title);
      if(/pokemon/.test(t))return 'pokemon';
      if(/nba|basketball/.test(t))return 'basketball';
      if(/nfl|football/.test(t))return 'football';
      if(/uefa|ucc|soccer/.test(t))return 'soccer';
      if(/formula 1|formule 1/.test(t))return 'f1';
      if(/wwe|wrestling/.test(t))return 'wrestling';
      if(/baseball|mlb/.test(t))return 'baseball';
      if(/lorcana|naruto|kpop|little pony|veefriends/.test(t))return 'other';
      if(/hockey|nhl|pwhl|habs|artifacts|black diamond|sp authentic|sp game used|the cup|credentials|engrain|trilogy|parkhurst|clear cut|opc|chronology|stature|skybox|fleer ultra|premier|ultimate|\bspx\b|\bice\b|extended|series [12]|series ext/.test(t) && !/topps/.test(t))return 'hockey';
      return 'other';
    }
    const stamp=value=>{const n=Number(value);return Number.isFinite(n)?n:0;};
    const cutoff=Date.now()/1000-30*86400;
    function recommended(a,b){
      const ac=stamp(a.dataset.created),bc=stamp(b.dataset.created),an=ac>=cutoff,bn=bc>=cutoff;
      return Number(bn)-Number(an)||(an&&bn?bc-ac:stamp(b.dataset.restocked)-stamp(a.dataset.restocked))||bc-ac||a.dataset.title.localeCompare(b.dataset.title,'fr');
    }
    function filter(){
      const term=norm(search.value.trim());let count=0;
      cards.sort((a,b)=>Number(b.dataset.available==='true')-Number(a.dataset.available==='true')||(sort.value==='recommended'?recommended(a,b):sort.value==='price-desc'?Number(b.dataset.price)-Number(a.dataset.price):sort.value==='price'?Number(a.dataset.price)-Number(b.dataset.price):a.dataset.title.localeCompare(b.dataset.title,'fr',{sensitivity:'base'}))).forEach(card=>{
        card.hidden=(!norm(card.dataset.title).includes(term))||(stock.checked&&card.dataset.available!=='true')||(sport&&sport.value==='all'&&card.dataset.available!=='true')||(sport&&sport.value!=='all'&&category(card)!==sport.value);if(!card.hidden)count++;grid.append(card);
      });
      root.querySelector('[data-catalog-count]').textContent=count+' produit'+(count>1?'s':'');root.querySelector('[data-catalog-empty]').hidden=count>0;
    }
    if(sport)sport.addEventListener('change',filter);
    search.addEventListener('input',filter);stock.addEventListener('change',filter);sort.addEventListener('change',filter);filter();
  }
  document.querySelectorAll('[data-catalog]').forEach(mount);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-catalog]').forEach(mount));
})();
